//namespace Pacem.Animations {
import { Easings } from './easings';
export class TweenService {
    run(from, to, duration, delay = 0, easing = Easings.linear, callback = null) {
        return new Promise((resolve, _) => {
            const now = (performance && performance.now()) || Date.now();
            const start = now + Math.abs(delay || 0);
            const end = start + Math.abs(duration || 0);
            //
            const fn = () => {
                const t = (performance && performance.now()) || Date.now();
                if (t >= start && t < end) {
                    const ct = (t - start) / duration;
                    const v = from + (easing || Easings.linear)(ct) * (to - from);
                    if (callback) {
                        callback(ct, v);
                    }
                }
                if (t < end) {
                    requestAnimationFrame(fn);
                }
                else {
                    if (callback) {
                        callback(1.0, to);
                    }
                    resolve();
                }
            };
            fn();
        });
    }
}
//}
